import PropTypes from 'prop-types';
import React from 'react';
import styles from './CancelReservation.scss';
import classNames from 'classnames';
import X from 'wix-style-react/new-icons/X';
import Modal from 'wix-style-react/Modal';
import Loader from 'wix-style-react/Loader';
import Dropdown from 'wix-style-react/Dropdown';
import _ from 'lodash';
import {Link} from 'react-router';

export class CancelReservation extends React.Component {
  constructor(props) {
    super(props);

    this.handleCancelReservationClick = this.handleCancelReservationClick.bind(this);

    this.comments = {
      EMPTY: props.i18n.get('modify_reservation_choose_reason', 'Choose Reason...'),
      NOT_CONFIRMED: props.i18n.get('modify_reservation_reason_1', 'Reservation not confirmed'),
      NOT_FEELING_TOO_WELL: props.i18n.get('modify_reservation_reason_2', 'I\'m not feeling too well'),
      CHANGE_OF_PLANS: props.i18n.get('modify_reservation_reason_3', 'Change of plans'),
      BAD_WEATHER: props.i18n.get('modify_reservation_reason_4', 'Bad Weather'),
      CUSTOM: props.i18n.get('modify_reservation_reason_costom', 'Custom')
    };

    this.options = _.chain(this.comments)
      .values()
      .map(comment => ({id: comment, value: comment}))
      .value();

    this.state = {
      comment: null,
      customComment: ''
    };
  }

  handleCancelReservationClick() {
    const {reservation} = this.props;
    const comment = this.state.comment === this.comments.CUSTOM ? this.state.customComment : this.state.comment;

    this.props.setReservationStatusRequest({
      reservationId: reservation.id,
      ownerToken: reservation.ownerToken,
      status: 'cancel',
      comment
    });
  }

  getTitle(i18n, isReservationPending, isNewlyCanceled) {
    if (isNewlyCanceled) {
      return i18n.get('reservations_email_customer_reservationinfo_title_canceledByCustomer', 'Your Reservation Is Cancelled');
    } else if (isReservationPending) {
      return i18n.get('modify_reservation_please_wait', 'Please wait...');
    } else {
      return i18n.get('modify_reservation_cancelling_reservation', 'Cancelling Reservation');
    }
  }

  getSubTitle(i18n, isNewlyCanceled) {
    if (isNewlyCanceled) {
      return i18n.get('reservations_email_customer_reservationinfo_subtitle_canceledByCustomer', 'Plans change – we get it! Thanks for letting us know. You’re always welcome to book for another time!');
    } else {
      return i18n.get('modify_reservation_cancelling_reservation_explain', 'Please take a moment to tell us why you’re cancelling.');
    }
  }

  render() {
    const {i18n, standAlone, hideBackButton, isReservationPending, isNewlyCanceled} = this.props;
    const isCustomComment = this.state.comment === this.comments.CUSTOM;
    const direction = i18n.isRtlDir() ? 'rtl' : 'ltr';
    const disabledStyle = isReservationPending ? {pointerEvents: 'none'} : {};
    const title = this.getTitle(i18n, isReservationPending, isNewlyCanceled);
    const subTitle = this.getSubTitle(i18n, isNewlyCanceled);

    const ret = (
      <div className={styles.cancelReservation} style={{direction}} data-hook="cancel-reservation">
        <div className={styles.closeButton}>
          { !hideBackButton && <Link style={disabledStyle} className={classNames(styles.button, styles.backButton, styles.xButton)} to={this.props.home} onClick={() => this.props.acknowledgeCancellation()}>
            <span className={styles.closeButtonInner} data-hook="close">
              <X className={styles.closeButtonSvg}/>
            </span>
          </Link> }
        </div>
        <div className={styles.title} data-hook="header">{title}</div>
        { !isReservationPending && <div className={styles.subTitle} data-hook="content">{subTitle}</div> }
        { !isReservationPending && !isNewlyCanceled && <div>
          <div className={styles.dropdown + ' ' + direction}>
            <Dropdown
              id="cancelReservationReasonDropdown"
              dataHook="cancelReservationReasonDropdown"
              selectedId={this.state.comment}
              options={this.options}
              placeholder={i18n.get('modify_reservation_choose_reason', 'Choose Reason...')}
              onSelect={option => this.setState({comment: option.value})}
              />
          </div>
        </div> }
        { !isReservationPending && !isNewlyCanceled && isCustomComment && <div className={styles.textareaWrapper}>
          <textarea
            id="cancelReservationCustomComment"
            className={styles.textarea}
            placeholder={i18n.get('modify_reservation_provide_your_reason', 'Provide your reason...')}
            onChange={event => this.setState({customComment: event.target.value})}
            />
        </div> }
        { isReservationPending && !isNewlyCanceled && <div className={styles.loaderWrapper}>
          <Loader size="medium"/>
        </div> }
        <div className={classNames(styles.divider, styles.bottomDivider)}/>
        <div className={styles.buttons} style={isNewlyCanceled ? {justifyContent: 'center'} : {}}>
          { !hideBackButton && <Link style={disabledStyle} className={classNames(styles.button, styles.backButton)} to={this.props.home} onClick={() => this.props.acknowledgeCancellation()} data-hook="back">
            {i18n.get('modify_reservation_back', 'Back')}
          </Link> }
          { !isNewlyCanceled && <div id="cancelReservationButton" style={disabledStyle} className={classNames(styles.button, styles.cancelReservationButton)} onClick={this.handleCancelReservationClick} data-hook="cancel-reservation-button">
            {i18n.get('modify_reservation_cancel_reservation', 'Cancel Reservation')}
          </div> }
        </div>
      </div>
    );

    let result = ret;
    if (!standAlone) {
      result = (
        <Modal
          isOpen
          shouldCloseOnOverlayClick
          onRequestClose={() => {
            this.props.acknowledgeCancellation(); this.props.router.push(this.props.home);
          }}
          contentLabel={'contentLabel'}
          >
          {ret}
        </Modal>
      );
    }

    return result;
  }
}

CancelReservation.displayName = 'CancelReservation';
CancelReservation.propTypes = {
  i18n: PropTypes.object,
  reservation: PropTypes.object,
  onCancel: PropTypes.func,
  setReservationStatusRequest: PropTypes.func,
  standAlone: PropTypes.bool,
  hideBackButton: PropTypes.bool,
  home: PropTypes.string,
  router: PropTypes.shape({
    push: PropTypes.func
  }),
  isReservationPending: PropTypes.bool,
  isNewlyCanceled: PropTypes.bool,
  acknowledgeCancellation: PropTypes.func
};
CancelReservation.defaultProps = {
  hideBackButton: false,
  standAlone: false
};

export default CancelReservation;



// WEBPACK FOOTER //
// ./components/CancelReservation/CancelReservation.js